import React, { useEffect, useRef, useState } from "react";
import "../../Registration/MainRegister/mainRegister.css";
import "../../Registration/MPin/fourDigitMPin.css";
import { IoEyeOutline } from "react-icons/io5";
import { IoEyeOffOutline } from "react-icons/io5";
import { useForm } from "react-hook-form";
import axios from "../../../axios";
import UpdateSuccessfully from "./updateSucess";

export default function SetNewMPIN() {
  const inputsRef = useRef([]);
  const confirmInputsRef = useRef([]);
  const [failedApiMsg, setFailedApiMsg] = useState("");
  const [mpin, setMpin] = useState(Array(6).fill(""));
  const [confirmMpin, setConfirmMpin] = useState(Array(6).fill(""));
  const [showConfirmMpin, setShowConfirmMpin] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [showMpin, setShowMpin] = useState(false);
  const [mpinError, setMpinError] = useState("");
  const [inputFieldsComplete, setInputFieldsComplete] = useState(false);
  const [mpinsMatch, setMpinsMatch] = useState(true);
  const [input, setInput] = useState({
    Mpin: null,
    confirmMpin: null,
    btnDisabled: true,
    type: false,
    type2: false,
  });

  const schoolCode = localStorage.getItem("schoolCode");

  const {
    formState: { errors },
  } = useForm();

  const [registerStateValidate, setRegisterStateValidate] = useState({
    isMpinValid: null,
    MpinValidationMsg: "",

    isConfirmMpinValid: null,
    ConfirmMpinValidationMsg: "",
  });

  const validateMpin = () => {
    const MpinRE = /^[0-9]*$/;
    let isvalid = false;

    // for username validation
    if (!input.Mpin) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isMpinValid: false,
        MpinValidationMsg: "MpinREq",
      });
      isvalid = false;
    } else if (input.Mpin && !MpinRE.test(input.Mpin)) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isMpinValid: false,
        MpinValidationMsg: "usernamePattern",
      });
      setInput({
        ...input,
        btnDisabled: true,
      });
      isvalid = false;
    } else {
      setRegisterStateValidate({
        ...registerStateValidate,
        isMpinValid: true,
        MpinValidationMsg: "",
      });

      isvalid = true;
    }

    // end part
    return isvalid;
  };

  const validateConfirmMpin = () => {
    const ConfirmMpinRE = /^[0-9]*$/;
    let isvalid = false;
    console.log(input.Mpin === input.confirmMpin, "match");
    console.log(ConfirmMpinRE.test(input.confirmMpin), "rejex");

    if (!input.confirmMpin) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isConfirmMpinValid: false,
        ConfirmMpinValidationMsg: "ConfirmMpinREq",
      });
      setInput({
        ...input,
        btnDisabled: true,
      });
      isvalid = false;
    } else if (input.Mpin && !ConfirmMpinRE.test(input.confirmMpin)) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isConfirmMpinValid: false,
        ConfirmMpinValidationMsg: "ConfirmMpinPattern",
      });
      setInput({
        ...input,
        btnDisabled: true,
      });

      isvalid = false;
    } else if (input.Mpin !== input.confirmMpin) {
      setRegisterStateValidate({
        ...registerStateValidate,
        isConfirmMpinValid: false,
        ConfirmMpinValidationMsg: "ConfirmMpinMatch",
      });
      setInput({
        ...input,
        btnDisabled: true,
      });

      isvalid = false;
    } else {
      setRegisterStateValidate({
        ...registerStateValidate,
        isConfirmMpinValid: true,
        ConfirmMpinValidationMsg: "",
      });
      setInput({
        ...input,
        btnDisabled: false,
      });
      isvalid = true;
      console.log(input.Mpin === null, "mena");
    }

    // end part

    return isvalid;
  };

  useEffect(() => {
    validateMpin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.Mpin]);

  useEffect(() => {
    validateConfirmMpin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.confirmMpin]);

  useEffect(() => {
    setRegisterStateValidate({
      ...registerStateValidate,
      isMpinValid: true,
      MpinValidationMsg: "",

      isConfirmMpinValid: true,
      ConfirmMpinValidationMsg: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [eye, seteye] = useState(true);
  const [password, setpassword] = useState("password");
  const Eye = () => {
    if (password === "password") {
      setpassword("text");
      seteye(false);
      setInput({
        ...input,
        type: true,
      });
    } else {
      setpassword("password");
      seteye(true);
      setInput({
        ...input,
        type: false,
      });
    }
  };

  const [eye2, seteye2] = useState(true);
  const [password2, setpassword2] = useState("password");
  const Eye2 = () => {
    if (password2 === "password") {
      setpassword2("text");
      seteye2(false);
      setInput({
        ...input,
        type2: true,
      });
    } else {
      setpassword2("password");
      seteye2(true);
      setInput({
        ...input,
        type2: false,
      });
    }
  };

  const School_ID = JSON.parse(localStorage.getItem("School_id"));

  const handleChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // only digits
    if (!val) return;

    const newMpin = [...mpin];
    newMpin[i] = val.slice(-1); // only last digit
    setMpin(newMpin);

    // update your existing form state
    setInput({
      ...input,
      Mpin: newMpin.join(""), // combine digits into one string
    });

    // move to next box if not last
    if (i < mpin.length - 1 && val) {
      inputsRef.current[i + 1].focus();
    }
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...mpin];

      if (mpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        inputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setMpin(newMpin);
      }

      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };

  const handleConfirmChange = (e, i) => {
    const val = e.target.value.replace(/[^0-9]/g, ""); // only digits
    if (!val) return;

    const newConfirmMpin = [...confirmMpin];
    newConfirmMpin[i] = val.slice(-1);
    setConfirmMpin(newConfirmMpin);

    setInput({
      ...input,
      confirmMpin: newConfirmMpin.join(""), // combine digits into one string
    });
    // Move focus forward
    if (i < 5 && val) {
      confirmInputsRef.current[i + 1].focus();
    }

    // Check if both MPINs are complete
    const mpinValue = mpin.join("");
    const confirmValue = newConfirmMpin.join("");

    if (mpinValue.length === 6 && confirmValue.length === 6) {
      setInputFieldsComplete(true);

      if (mpinValue !== confirmValue) {
        setMpinError("MPINs do not match");
        setMpinsMatch(false);
      } else {
        setMpinError("");
        setMpinsMatch(true);
      }
    } else {
      setInputFieldsComplete(false);
      setMpinError("");
      setMpinsMatch(false);
    }
  };

  const handleKeyDownConfirmPin = (e, i) => {
    if (e.key === "Backspace") {
      const newMpin = [...confirmMpin];

      if (confirmMpin[i]) {
        // Case 1: current box has a digit → clear it
        newMpin[i] = "";
        setConfirmMpin(newMpin);
      } else if (i > 0) {
        // Case 2: current box is empty → move to previous box and clear it
        confirmInputsRef.current[i - 1].focus();
        newMpin[i - 1] = "";
        setConfirmMpin(newMpin);
      }

      e.preventDefault(); // stop default backspace behavior (cursor movement)
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let User = {
      user_id: School_ID,
      mpin: input.confirmMpin,
      school_code: schoolCode,
    };
    try {
      const res = await axios.put(`/api/v1/teacherAuth/reset/mpin`, User);
      res && setSucess(true);
    } catch (error) {
      console.log(error);
    }
  };

  const toggleShowMpin = () => {
    setShowMpin(!showMpin);
  };

  const toggleShowConfirmMpin = () => {
    setShowConfirmMpin(!showConfirmMpin);
  };

  return (
    <div className="TotalContainer">
      <div className="MainContainer col-12 p-0  d-md-flex ">
        <div className="banner_box col-md-3 col-12 p-0">
          <img
            className="banner_img "
            src="/Register-img/baner_img.jpg"
            alt="banner img"
          ></img>
        </div>
        <div className="form_box_verify col-md-9 col-12 p-0">
          <div>
            <div className="total_logo_regist">
              <img
                className="logo_registration"
                src="/Register-img/Register_logo.png"
                alt="register logo"
              ></img>
            </div>
            <div className="title_regis">Set 6 Digit M-PIN</div>

            <form>
              <div className="input_box_mpin">
                {/* <input
                                    className={registerStateValidate.isMpinValid === false ? ` ${errors.name && "invalid"}` : ""}
                                    onChange={(e) => setInput({
                                        ...input,
                                        Mpin: e.target.value
                                    })}
                                    id='newMpin'
                                    type={password}
                                    name="Mpin"
                                    placeholder="New Pin"
                                    maxLength={4}
                                    autocomplete="off"
                                ></input> */}
                {mpin?.map((val, i) => (
                  <input
                    className={
                      registerStateValidate.isMpinValid === false
                        ? ` ${errors.name && "invalid"}`
                        : ""
                    }
                    key={i}
                    ref={(el) => (inputsRef.current[i] = el)}
                    type={showMpin ? "text" : "password"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={val}
                    placeholder="_"
                    onChange={(e) => handleChange(e, i)}
                    onKeyDown={(e) => handleKeyDown(e, i)}
                    style={{
                      width: 44,
                      height: 52,
                      textAlign: "center",
                      fontSize: 24,
                      border: "1px solid #ccc",
                      borderRadius: 8,
                    }}
                  />
                ))}

                {/* <span onClick={Eye} className='Eye_login'>
                                    {eye ? <IoEyeOffOutline /> :
                                        <IoEyeOutline />}
                                </span> */}
                <span onClick={toggleShowMpin} className="Eye_login">
                  {showMpin ? <IoEyeOutline /> : <IoEyeOffOutline />}
                </span>
              </div>

              {registerStateValidate.isMpinValid === false &&
                registerStateValidate.MpinValidationMsg === "MpinREq" && (
                  <small className="text-danger">{"Mpin is Required"}</small>
                )}
              {registerStateValidate.isMpinValid === false &&
                registerStateValidate.MpinValidationMsg ===
                  "usernamePattern" && (
                  <small className="text-danger">{"Enter Only Numbers"}</small>
                )}

              <div className="input_box_mpin mt-3">
                {/* <input
                                    className={registerStateValidate.isConfirmMpinValid === false ? `${errors.name && "invalid"}` : ""}
                                    onChange={(e) => setInput({
                                        ...input,
                                        confirmMpin: e.target.value
                                    })}
                                    id='newMpin'
                                    type={password2}
                                    name="confirmMpin"
                                    placeholder="Confirm Pin"
                                    maxLength={4}
                                    pattern="[0-9]*"
                                    autocomplete="off"
                                ></input>
                                <span onClick={Eye2} className='Eye_login'>
                                    {eye2 ? <IoEyeOffOutline /> :
                                        <IoEyeOutline />}
                                </span> */}
                {confirmMpin?.map((val, i) => (
                  <input
                    key={i}
                    ref={(el) => (confirmInputsRef.current[i] = el)}
                    type={showConfirmMpin ? "text" : "password"}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={val}
                    placeholder="_"
                    onChange={(e) => handleConfirmChange(e, i)}
                    onKeyDown={(e) => handleKeyDownConfirmPin(e, i)}
                    style={{
                      width: 44,
                      height: 52,
                      textAlign: "center",
                      fontSize: 24,
                      border: "1px solid #ccc",
                      borderRadius: 8,
                    }}
                  />
                ))}
                <span onClick={toggleShowConfirmMpin} className="Eye_login">
                  {showConfirmMpin ? <IoEyeOutline /> : <IoEyeOffOutline />}
                </span>
              </div>

              {registerStateValidate.isConfirmMpinValid === false &&
                registerStateValidate.ConfirmMpinValidationMsg ===
                  "ConfirmMpinREq" && (
                  <small className="text-danger">
                    {"Confirm pin Required"}
                  </small>
                )}
              {registerStateValidate.isConfirmMpinValid === false &&
                registerStateValidate.ConfirmMpinValidationMsg ===
                  "ConfirmMpinPattern" && (
                  <small className="text-danger">{"Enter Only Numbers"}</small>
                )}
              {registerStateValidate.isConfirmMpinValid === false &&
                registerStateValidate.ConfirmMpinValidationMsg ===
                  "ConfirmMpinMatch" && (
                  <small className="text-danger">
                    {"Confirm pin is not match"}
                  </small>
                )}
            </form>

            <div>
              <button
                class="btn btn"
                id={
                  input.btnDisabled ? "btn_disabled" : "Register_continue_btn"
                }
                onClick={handleSubmit}
                disabled={input.btnDisabled}
                type="button"
              >
                Continue{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
      {sucess && <UpdateSuccessfully type={"pin"} />}
    </div>
  );
}
